export const INIT_ROOT = 'INIT_ROOT';
export const INIT_MAIN = 'INIT_MAIN';
export const TOGGLE_OPTION = 'TOGGLE_OPTION';
export const TOGGLE_OPTION_SUCCESS = 'TOGGLE_OPTION_SUCCESS';
export const TOGGLE_OPTION_ERROR = 'TOGGLE_OPTION_ERROR';
export const TOGGLE_OPTION_CONFLICT = 'TOGGLE_OPTION_CONFLICT';
export const TOGGLE_OPTION_CONFLICT_RESOLVE = 'TOGGLE_OPTION_CONFLICT_RESOLVE';
export const TOGGLE_OPTION_CONFLICT_CANCEL = 'TOGGLE_OPTION_CONFLICT_CANCEL';
export const UPDATE_CONFIG = 'UPDATE_CONFIG';
export const UPDATE_CONFIG_SUCCESS = 'UPDATE_CONFIG_SUCCESS';
export const UPDATE_CONFIG_ERROR = 'UPDATE_CONFIG_ERROR';
export const UPDATE_POSTAL_CODE = 'UPDATE_POSTAL_CODE';
export const TOGGLE_PRIMARY_IMAGE_STATE = 'TOGGLE_PRIMARY_IMAGE_STATE';
export const FETCH_REGIONAL_INCENTIVES = 'FETCH_REGIONAL_INCENTIVES';
export const FETCH_REGIONAL_INCENTIVES_SUCCESS =
  'FETCH_REGIONAL_INCENTIVES_SUCCESS';
export const TRANSITION = 'TRANSITION';
export const BREAKPOINT_CHANGED = 'BREAKPOINT_CHANGED';
export const UPDATE_INTERIOR_INDEX = 'UPDATE_INTERIOR_INDEX';
export const UPDATE_EXTERIOR_INDEX = 'UPDATE_EXTERIOR_INDEX';
export const TOGGLE_CONVERTIBLE_TOP = 'TOGGLE_CONVERTIBLE_TOP';
export const UPDATE_AUTH_TOKEN = 'UPDATE_AUTH_TOKEN';
export const START_OVER = 'START_OVER';
export const START_OVER_SUCCESS = 'START_OVER_SUCCESS';
export const IS_SELECTION_REVEALED_CHANGED = 'IS_SELECTION_REVEALED_CHANGED';
export const IS_BODY_TYPE_REVEALED_CHANGED = 'IS_BODY_TYPE_REVEALED_CHANGED';
export const SAVED_BUILD_COUNT = 'SAVED_BUILD_COUNT';
export const CLEAR_OPTION_TOGGLED = 'CLEAR_OPTION_TOGGLED';
export const IS_LEGAL_DISCLOSURE_OPENED_CHANGED =
  'IS_LEGAL_DISCLOSURE_OPENED_CHANGED';
export const FETCH_RESERVATION = 'FETCH_RESERVATION';
export const UPDATE_PRE_ORDER_STATUS = 'UPDATE_PRE_ORDER_STATUS';
export const UPDATE_RESERVATION = 'UPDATE_RESERVATION';
